/*
*  AGP events
*  Fichier de gestion orgas
*/

import $ from "jquery";
import 'jquery-ui';
import Common from "./agp_common";


let orga = {};

export default class Orgas {

    constructor(el) {
        this.DOM = {el: el};
    }

    init() {
        let _this = this;

        $(document).on("change", "select[name=orga_company_id]", function () {
            let _company_id = parseInt($(this).val());
            let $select = $('select._orga_events');

            if (_company_id != "") {

                $select.empty();

                $("select[name=_list_events] > option").each(function (i, item) {

                    let _company = parseInt($(this).data("company"));
                    let _id = $(this).val();
                    let _name = $(this).text();
                    if (_company === _company_id) {
                        var $opt = $('<option />', {
                            value: _id,
                            text: _name
                        });
                        $select.append($opt);
                    }

                });

                $select.multipleSelect('refresh');

            }
        });

        $(document).on("change", "select[name=organizer_level]", function () {
            let orga_level = parseInt($(this).val());
            if (orga_level === 1) {
                $("._info_secondaire").show();
            } else {
                $("._info_secondaire").hide();
            }
        });


        // activer / désactiver tous les droits
        $(document).on('click', 'input[name^="all"]', function() {
            var isChecked = $(this).prop('checked');
            var name = $(this).attr('name');
            var value = name.match(/\[(.*)\]/)[1];
            $('input[name^="droit[' + value + ']"]').prop('checked', isChecked);
        });


        // gestion checkbox all si others checked or not
        $(document).on('click', 'input[name^="droit"]', function() {

            var name = $(this).attr('name');
            var value = $(this).attr('name').match(/\[(.*?)\]/)[1];
            var type = name.split('[')[2].replace(']','');
            if(type!='read'){
                var isChecked = $('input[name^="droit[' + value + ']"]:not([name="droit[' + value + '][read]"])').is(':checked');
                $('input[name="droit[' + value + '][read]"]').prop('checked', isChecked);
            }
            var isChecked_all = $('input[name^="droit[' + value + ']"]').not(':checked').length == 0;
            $('input[name="all[' + value + ']"]').prop('checked', isChecked_all);
        });

    }

}